import * as React from 'react';
import { MenuItem, Grid, IconButton, Typography, Paper, AppBar, Toolbar, Table, TableHead, TableRow, TableCell, TableBody, Dialog, DialogActions, DialogContentText, DialogContent, DialogTitle, TextField, Button } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import {observable, computed, action} from 'mobx';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import {DatePicker} from "material-ui-pickers"
import 'moment/locale/cs';
import Turnus from 'src/models/Turnus'
import TurnusProgressIndicator from 'src/components/TurnusProgressIndicator'
import TurnusNewDialog from './TurnusNewDialog';
import { OrderHelper } from 'src/classes/OrderHelper';
import Cenik from 'src/models/Cenik';

@inject('turnusStore')
@inject('objednavkaStore')
@inject('ciselnikyStore')
@observer
export class ClientTurnusesSection extends React.Component<any> {

    @observable private klientId: number;

    constructor(props: Readonly<any>) {
        super(props);
        this.klientId = props.klientId;
        this.props.turnusStore.loadForClient(this.props.klientId);
    }

    @observable private isNewTurnusDialogOpened: boolean = false;
    @observable private isDeleteDialogOpened: boolean = false;
    @observable private isTurnusDialogOpened: boolean = false;

    // New turnus
    private turnusToDelete: Turnus = undefined;
    private turnusEdit: Turnus = new Turnus();

    private disableAllButMonday = date => {
        return moment(date).toDate().getDay() !== 1;
    }
    private disableAllButFriday = date => {
        return moment(date).toDate().getDay() !== 5;
    }

    @action
    private onSaveNewTurnus = (turnus: Turnus) => {
        this.isNewTurnusDialogOpened = !this.isNewTurnusDialogOpened;
        turnus.idKlient = this.klientId;
        turnus.idObjednavka = 0;
        this.props.turnusStore.createNewTurnus(turnus);
    }

    @action
    private onCloseDialog = event => {
        this.isNewTurnusDialogOpened = !this.isNewTurnusDialogOpened;
    }

    @action
    private handleAddTurnus = event => {
        this.isNewTurnusDialogOpened = true;
    }

    @action
    private handleTurnusRowClick = turnus => evt => {
        if(evt.nativeEvent.toElement.nodeName === "TD") {
            this.turnusEdit = turnus;
            this.isTurnusDialogOpened = true;
        }
    }

    @action
    private handleTurnusDeleteClick = turnus => evt => {
        this.turnusToDelete = turnus;
        this.isDeleteDialogOpened = true;
    }

    @action
    private onCloseTurnusDialog = event => {
        this.isTurnusDialogOpened = !this.isTurnusDialogOpened;
    }

    // Turnus edit dialog
    @action
    private handleEditTurnusDateChange = field => date => {
        this.turnusEdit[field] = moment(date).toDate();
    }
    @action
    private handleTurnusValueChange = field => event => {
        this.turnusEdit[field] = event.target.value;
    }
    @action
    private handleTurnusUpdate = () => {
        this.props.turnusStore.updateTurnus(this.turnusEdit)
            .then(turnus => {
                this.isTurnusDialogOpened = false;
            });
    }

    private handleDeleteDialogOK = event => {
        this.props.turnusStore.deleteTurnus(this.turnusToDelete)
            .then(turnus => {
                this.turnusToDelete = undefined;
                this.isDeleteDialogOpened = !this.isDeleteDialogOpened;
            });
    }
    @action
    private onCloseDeleteDialog = event => {
        this.isDeleteDialogOpened = !this.isDeleteDialogOpened;
    }

    private getTurnusStavLabel(stav: string) {
        return OrderHelper.prettyPrintState(stav);
    }

    public render() {
        return (
            <div>
                <Paper square style={{ marginBottom: 8 }}>
                    <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#90a4ae'}}>
                        <Toolbar variant="dense">
                        <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                            Turnusy
                        </Typography>
                        <IconButton color="inherit" aria-label="Done" onClick={this.handleAddTurnus}>
                            <AddIcon />
                        </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Grid container spacing={8}>
                        <Grid item style={{ marginLeft: 8, marginTop: 10 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{paddingRight: 36}}>Průběh</TableCell>
                                        <TableCell style={{paddingRight: 36}}>Od - do</TableCell>
                                        <TableCell style={{paddingRight: 36}}>Program</TableCell>
                                        <TableCell style={{paddingRight: 36}}>Objednávka</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        this.props.turnusStore.turnuses.map((turnus: Turnus) => (
                                            <TableRow hover key={turnus.id} onClick={this.handleTurnusRowClick(turnus)}>
                                                <TableCell style={{paddingRight: 36}}>
                                                    <TurnusProgressIndicator length={turnus.getLength()} progress={turnus.getProgress()} />
                                                </TableCell>
                                                <TableCell style={{paddingRight: 36}}>{turnus.od.toLocaleDateString() + " - " + turnus.do.toLocaleDateString()}</TableCell>
                                                <TableCell style={{paddingRight: 36}}>{this.props.ciselnikyStore.getProgramByID(turnus.program).value} kJ</TableCell>
                                                <TableCell style={{paddingRight: 36}}>{turnus.idObjednavka === 0 ? '' : this.getTurnusStavLabel(this.props.objednavkaStore.getObjednavkaByID(turnus.idObjednavka).stav)}</TableCell>
                                                <TableCell style={{paddingRight: 36}}>
                                                    <IconButton color="inherit" aria-label="Delete" onClick={this.handleTurnusDeleteClick(turnus)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                </Paper>
                    <Dialog
                        open={this.isTurnusDialogOpened}
                        onClose={this.onCloseTurnusDialog}
                        aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Turnus</DialogTitle>
                        <DialogContent>
                                <Grid container spacing={8}>
                                    <Grid item>
                                        <DatePicker label="Od" value={this.turnusEdit.od} onChange={this.handleEditTurnusDateChange('od')} shouldDisableDate={this.disableAllButMonday}/>
                                    </Grid>
                                    <Grid item>
                                        <DatePicker label="Do" value={this.turnusEdit.do} onChange={this.handleEditTurnusDateChange('do')} shouldDisableDate={this.disableAllButFriday}/>
                                    </Grid>
                                    <Grid item>
                                        <TextField label="Program" id="turnus-program" select onChange={this.handleTurnusValueChange('program')} 
                                            value={this.turnusEdit.program}>
                                                {this.props.ciselnikyStore.getAllValidPrograms().map((prg: Cenik) => (
                                                    <MenuItem value={prg.value}>{prg.value} kJ ({prg.price} Kč/den)</MenuItem>
                                                ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onCloseTurnusDialog} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.handleTurnusUpdate} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.isDeleteDialogOpened}
                        onClose={this.onCloseDeleteDialog}
                        aria-labelledby="delete-confirm-dialog">
                        <DialogTitle id="delete-confirm-dialog">Smazat</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Opravdu smazat?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onCloseDeleteDialog} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.handleDeleteDialogOK} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <TurnusNewDialog 
                        open={this.isNewTurnusDialogOpened} 
                        onClose={this.onCloseDialog} 
                        onAdd={this.onSaveNewTurnus} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ClientTurnusesSection.tsx